<template>
  <div class="page">
    <Header></Header>
    <div class="title">
      <div class="title-text">{{postion.name}}</div>
      <van-tag v-if="postion.statusName && postion.statusName=='招聘中'" color="#e9f9f0" text-color="#27C36F">{{item.positionStatusName}}</van-tag>
      <van-tag v-if="postion.statusName && postion.statusName!='招聘中'" color="#F5F7FA" text-color="#9499B0">{{item.positionStatusName}}</van-tag>
      <div class="title-ext" @click="gotoResume">我的简历</div>
    </div>
    <div class="body">
      <div class="box">
        <div class="step-box" v-for="(item,i) in list" :key="item.id">
            <div class="step">
              <img v-if="i==(list.length-1)" :src="require('@/assets/approve.png')" class="step-icon" />
              <img v-if="i<(list.length-1)" :src="require('@/assets/approved.png')" class="step-icon" />
              <div v-if="i<(list.length-1)" class="step-line"></div>
            </div>
            <div class="step-content">
                <div class="step-content-status">{{item.statusName}}</div>
                <div  v-for="(iitem,ii) in item.list" :key="item.id+'i'+ii">
                  <div v-if="iitem.comment" class="step-content-box">{{iitem.comment+"　"+(iitem.comment.indexOf('重新投递')!=-1?'':iitem.operationTimeShow)}}</div>
                  <div class="step-content-time">{{iitem.createdTimeShow}}</div>
                </div>
            </div>
        </div>
      </div>
      <NoData v-if="!loading && (!list || list.length==0)" message="暂无进度"></NoData>
      <SafeBottom></SafeBottom>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Tag,
  Toast,
} from "vant";
import Utils from "../utils/Utils";
import Request from "../utils/Request";
import Urls from "../utils/Urls";
import wx from "weixin-js-sdk";
import NoData from "./NoData";
import Header from "./Header1";
import Footer from "./Footer";
import SafeBottom from "./SafeBottom";

Vue.use(Tag);
export default {
  name: "Process",
  components:{
    SafeBottom,
    NoData,
    Header,
    Footer
  },
  data(){
    return {
      app:"",
      postion:{
      },
      loading:false,
      list: [],
    }
  },
  mounted: function()
  {
    this.app=Utils.getApp();
    this.getPostion();
    this.getResumeProcess();
  },
  methods: {
    getPostion() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getPositionDetail, { positionId:this.$route.query.positionId }).then(data => {
        Toast.clear();
        if (data) {
          this.postion = data;
        }
      });
    },
    getResumeProcess() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getDeliveryProcessList, { id:this.$route.query.id }).then(data => {
        Toast.clear();
        if (data) {
          this.list = data;
        }
      });
    },


    gotoResume(){
      if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url='+encodeURIComponent('/resume'),
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/resume'});
      }
    }
  }
}
</script>

<style scoped>
.page{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.title{
  margin: 16px 20px;
  display: flex;
  align-items: center;
}
.title-text{
  flex: 1;
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.van-tag{
  margin: 0 8px;
}
.title-ext{
  height: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #3A5FFF;
  text-align: right;
  line-height: 16px;
  font-weight: 400;
}
.body{
  flex:1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.box{
  margin: 0 20px 16px;
}
.step-box{
  display: flex;
  align-items: stretch;
  border: 0;
  margin: 0;
  padding: 0;
}
.step{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.step-icon{
  width: 16px;
  height: 16px;
}
.step-line{
  width: 1px;
  flex: 1;
  background-color:#E6EBF5;
}
.step-content{
  margin-left: 12px;
  flex: 1;
}
.step-content-status{
  height: 18px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #20253F;
  letter-spacing: -0px;
  line-height: 18px;
  font-weight: 500;
}
.step-content-box{
  margin: 6px 0 0;
  width: 80%;
  padding: 10px;
  background: #F8F9FC;
  border-radius: 6px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #6F778F;
  letter-spacing: -0px;
  font-weight: 400;
}
.step-content-box-split{
  margin: 0 8px;
  display: inline-block;
  width: 1px;
  height: 12px;
  background-color: #E6EBF5;
  vertical-align: middle;
}
.step-content-time{
  margin: 6px 0 16px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #9499B0;
  letter-spacing: -0px;
  font-weight: 400;
}
</style>